/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Invalid_CredentialsInputs */

const nl_auth_api_errors_invalid_credentials = /** @type {(inputs: Auth_Api_Errors_Invalid_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ongeldige inloggegevens`)
};

/**

* @param {Auth_Api_Errors_Invalid_CredentialsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_invalid_credentials = /** @type {((inputs?: Auth_Api_Errors_Invalid_CredentialsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Invalid_CredentialsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_invalid_credentials(inputs)
});
export { auth_api_errors_invalid_credentials as "auth.api_errors.invalid_credentials" }